import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import IntelligenceCreate from "@/pages/IntelligenceCreate";

export const Route = createFileRoute("/_app/intelligence/create")({
  component: () => (
    <PageGate pageKey="intelligence"><IntelligenceCreate /></PageGate>
  ),
});
